import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { FileText, Image as ImageIcon } from "lucide-react";
import { API_URL } from "@/api/constant";

interface FilePreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  fileUrl: string | null;
  title?: string;
}

const FilePreviewModal: React.FC<FilePreviewModalProps> = ({
  isOpen,
  onClose,
  fileUrl,
  title = "Document Preview",
}) => {
  if (!fileUrl) return null;

  const fullUrl =
    fileUrl.startsWith("http") || fileUrl.startsWith("blob:")
      ? fileUrl
      : `${API_URL}/${fileUrl}`;
  const isPdf =
    fileUrl.toLowerCase().endsWith(".pdf") ||
    fileUrl.toLowerCase().includes("application/pdf");

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className={`${isPdf ? "max-w-6xl min-w-2xl w-[100vw]" : "max-w-2xl w-fit"
          } max-h-[90vh] flex flex-col p-5 sm:p-6 overflow-hidden`}
      >
        <DialogHeader className="flex flex-row items-center gap-2 pb-3 border-b border-border pr-8">
          {isPdf ? (
            <FileText className="w-5 h-5 text-rose-600 shrink-0" />
          ) : (
            <ImageIcon className="w-5 h-5 text-primary shrink-0" />
          )}
          <DialogTitle className="text-base font-semibold text-foreground truncate">
            {title}
          </DialogTitle>
        </DialogHeader>

        <div className="flex-1 w-full flex items-center justify-center overflow-auto mt-3 bg-slate-50/80 rounded-xl p-2 min-h-[300px]">
          {isPdf ? (
            <iframe
              src={`${fullUrl}#toolbar=1`}
              title={title}
              className="w-full h-[72vh] rounded-lg border border-slate-200"
            />
          ) : (
            <img
              src={fullUrl}
              alt={title}
              className="max-h-[72vh] max-w-full object-contain rounded-lg shadow-sm mx-auto select-none"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FilePreviewModal;

